import './App.css';
import Home from './pages/Home/index'

function App() {
  return (
    <div className="App">
      <Home/>
    </div>
  );
}

export default App;
